import { ENDPOINT_AI } from '../config'
import type { AiUsageResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Admin variant of /ai/usage. Same JSON shape as the UseAi-gated read but:
 *   - Gated by ManageAiSettings instead of UseAi.
 *   - Skips the per-workspace AiEnabled kill-switch so admins can read
 *     historical spend + quota limits while AI is disabled.
 *
 * The Settings → AI tab calls this endpoint specifically (not /ai/usage)
 * so the toggle + reindex flows can render while AI is off.
 */
export async function getAiUsage(
  workspaceSlug: string,
): Promise<AiUsageResponse> {
  const response = await AuthAxios.get<AiUsageResponse>(
    `${ENDPOINT_AI(workspaceSlug)}/admin/usage`,
  )
  return response.data
}
